import PropTypes from "prop-types";

import EOBlock from "./EoBlock";
import StatusPills from "./StatusPills";

import { makeKeyFor } from "./differentiationHierarchyPanelUtils";

const GLERow = ({ dataType, includedKeys, node, onToggleItem, selectedKeys }) => {
    const gleKey = makeKeyFor(node, dataType);
    const gleChecked = !!selectedKeys?.has?.(gleKey);
    const alreadyIncluded = includedKeys?.has?.(gleKey) === true;

    return (
        <div className="diff-gle-row">
            <div className="diff-gle-row__header">
                <div className="diff-gle-row__label">
                    <span className="diff-badge diff-badge--gle">GLE</span>
                    {node.label}
                </div>

                <div className="diff-gle-row__actions">
                    {node.reportFlag && <StatusPills dataType={dataType} node={node} includedKeys={includedKeys} />}
                    {dataType === "CURRENT" && node.reportFlag && node.included && (
                        <div className="form-check form-check-inline align-middle m-0">
                            <input
                                className="form-check-input d-none"
                                type="checkbox"
                                checked={gleChecked}
                                onChange={() => onToggleItem?.(node)}
                                id={`exclude-${gleKey}`}
                            />
                            <label
                                htmlFor={`exclude-${gleKey}`}
                                className={`diff-action-btn ${gleChecked ? "diff-action-btn--active" : ""}`}
                            >
                                {gleChecked ? "Excluded" : "Exclude"}
                            </label>
                        </div>
                    )}
                    {dataType === "DIFF" && !alreadyIncluded && node.reportFlag && (
                        <div className="form-check form-check-inline align-middle m-0">
                            <input
                                className="form-check-input d-none"
                                type="checkbox"
                                checked={gleChecked}
                                onChange={() => onToggleItem?.(node)}
                                id={`add-${gleKey}`}
                            />
                            <label
                                htmlFor={`add-${gleKey}`}
                                className={`diff-action-btn ${gleChecked ? "diff-action-btn--active" : ""}`}
                            >
                                {gleChecked ? "Added" : "Add"}
                            </label>
                        </div>
                    )}
                </div>
            </div>

            {node.children?.map((eo) => (
                <EOBlock
                    key={eo.id ?? eo.key}
                    dataType={dataType}
                    includedKeys={includedKeys}
                    node={eo}
                    onToggleItem={onToggleItem}
                    selectedKeys={selectedKeys}
                />
            ))}
        </div>
    );
};

GLERow.propTypes = {
    dataType: PropTypes.string,
    includedKeys: PropTypes.object,
    node: PropTypes.object.isRequired,
    onToggleItem: PropTypes.func,
    selectedKeys: PropTypes.instanceOf(Set)
};

GLERow.defaultProps = {
    dataType: "",
    includedKeys: {},
    onToggleItem: () => {},
    selectedKeys: new Set()
};

export default GLERow;
